import api from '@/api/purchase'

const state = {
  // internal
  internal: {},
  purchaseDate: ''
}

const getters = {
  purchaseRecentDate: state => state.purchaseDate,
  targetSku: state => state.internal.targetSku
}

const mutations = {
  initialize: (state, args) => {
    state.internal = args
  },
  setPurchaseRecentDate: (state, data) => {
    let max = 0
    for (let item of data.items) {
      if (max < Number(item.purchaseDate)) {
        max = Number(item.purchaseDate)
      }
    }
    state.purchaseDate = (max === 0) ? '' : String(max)
  }
}

const actions = {
  initialize: ({ commit }, args) => {
    commit('initialize', args)
  },
  getPurchaseRecentDate: ({ commit }) => {
    const params = {
      jan: state.internal.targetSku
    }
    return api.getPurchase(params).then(data => {
      commit('setPurchaseRecentDate', data)
    })
  },
  updateTargetSku: ({ commit, dispatch }, args) => {
    commit('initialize', args)
    dispatch('getPurchaseRecentDate')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/purchase.js